import 'react';
import '@backstage/version-bridge';
import '@backstage/errors';
import { createApiRef } from '../system/ApiRef.esm.js';

var FeatureFlagState = /* @__PURE__ */ ((FeatureFlagState2) => {
  FeatureFlagState2[FeatureFlagState2["None"] = 0] = "None";
  FeatureFlagState2[FeatureFlagState2["Active"] = 1] = "Active";
  return FeatureFlagState2;
})(FeatureFlagState || {});
const featureFlagsApiRef = createApiRef({
  id: "core.featureflags"
});

export { FeatureFlagState, featureFlagsApiRef };
//# sourceMappingURL=FeatureFlagsApi.esm.js.map
